import gql from "graphql-tag";

const SUBMITFORM_MUTATION = gql`
  mutation SubmitForm($formId:String!, $payload:JSONObject!) {
    submitForm(id:$formId, payload:$payload)
  }
`;
export default SUBMITFORM_MUTATION;